




import {Component, Prop, Vue} from 'vue-property-decorator'
import DataGrid, {DataType} from '@/components/DataGrid.vue'
import DataGridLink from "@/components/buttons/DataGridLink.vue"
import * as complianceLinks from "@/data/sources/complianceLinks"
import {executeQuery} from "@/data/repos/query";

@Component({
  components: {
    DataGrid,
  },
})
export default class ComplianceElementScoreOverTimeDrillDown extends Vue {
  @Prop() public args!: { locationId: number, elementId: number, expiry: string, isCompliant: number }
  public fields = [
    {name: 'ElementDescription', title: 'Element', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: complianceLinks.element},
    {name: 'BuildingName', title: 'Building', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: complianceLinks.building},
    {name: 'Code', title: 'Code', dataType: DataType.Text, sort: 1},
    {name: 'Reason', title: 'Reason', dataType: DataType.Text, sort: 1},
    {name: 'ExpiryDate', title: 'Expiry Date', dataType: DataType.Date, sort: 1},
    {name: 'responsiblePerson', title: 'Responsible Person', dataType: DataType.Text, sort: 1},
    {name: 'riskLabel', title: 'Risk', dataType: DataType.Text, sort: 1},
    // {name: 'Risk', title: 'Risk Value', dataType: DataType.Number, sort: 1},
  ]

  public getData(offset = 0, limit = 250) {
    // --DECLARE @locationId INT
    // --DECLARE @expiry varchar(3)         --jan,feb,....dec or sun, mon....sat
    // --DECLARE @isCompliant INT           --0 or 1
    // --DECLARE @show INT                  --0 Month, 1 Weekday
    if (this.args.isCompliant == 1)
      return executeQuery("idr", "compliance.elementScoreOverTimeCompliantBuildingsDrilldown",
        {locationId: this.args.locationId, elementId: this.args.elementId},
        undefined,
        offset, limit)
    else
      return executeQuery("idr", "compliance.elementScoreOverTimeDrillDown",
        {locationId: this.args.locationId, elementId: this.args.elementId, expiry: this.args.expiry, isCompliant: this.args.isCompliant, show: 0},
        undefined,
        offset, limit)
  }
}
